import script from "./DialogForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogForm.vue?vue&type=script&setup=true&lang=js"

import "./DialogForm.vue?vue&type=style&index=0&id=b95648f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b95648f4"]])

export default __exports__